/**
 * B255 — resolve which coach wrote a `CoachStories` card.
 *
 * `CoachInsight` carries no coach id of its own (`id` is the fixture/rule id,
 * e.g. 'race-day' in the demo fixture vs 'race-countdown' from the real rules
 * engine — the two don't even agree with each other). Both sources DO agree
 * on `color`: it is always that coach's `var(--c-{id})` token — the fixture
 * sets it by hand (`routes/today.tsx`), the real engine derives it from the
 * same short coach id `coachInsightRules.ts` fires the rule under
 * (`var(--c-${r.coach})`). `coaches.ts` stores that exact string as each
 * `Coach.colorVar`, so matching on it resolves the real coach with no new
 * field on `CoachInsight` and no hardcoded id table that could drift from
 * the canonical map.
 */
import { COACHES, type Coach } from '../../lib/coaches';
import type { CoachInsight } from './CoachStories';

export function coachForInsight(insight: CoachInsight): Coach | undefined {
  return COACHES.find((c) => c.colorVar === insight.color);
}
